import React from "react";
import { withRouter } from "../withRouter.js";
import "../App.css";
import "../register.css";
import errorStatus2 from "../assets/Error2.png";
import { Navigate } from "react-router-dom";

// the login form will display if there is no session token stored.  This will display
// the login form, and call the API to authenticate the user and store the token in
// the session.

export default class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      username: "",
      password: "",
      alanmessage: "",
      sessiontoken: "",
      cancelClicked: false,
      submitClicked: false,
      retypedPassword: "",
      userNameErrors: false,
      emailErrors: false,
      passwordErrors: false,
      passwordreErrors: false,
      generalErrors: false,
      generalOutput: "Hello Michael",
      passwordErrorsReturn: "",
      passwordreErrorsReturn: "",
    };
    // this.onCancel = this.onCancel.bind(this)
  }


  // change handlers keep the state current with the values as you type them, so
  // the submit handler can read from the state to hit the API layer
  emailChangeHandler = event => {
    if (event.target.value === "") {
      this.setState({
        emailErrors: true,
      });
      return;
    }
    this.setState({
      email: event.target.value
    });
  };

  usernameChangeHandler = event => {
    if (event.target.value === "") {
      this.setState({
        userNameErrors: true,
      });
      return;
    }
    this.setState({
      username: event.target.value
    });
  };

  passwordChangeHandler = event => {
    if (event.target.value === "") {
      this.setState({
        passwordErrors: true,
        passwordErrorsReturn: "Invalid password!"
      });
      return;
    }
    this.setState({
      password: event.target.value,
    });
  };

  retypeCheck = event => {
    this.setState({
      retypedPassword: event.target.value,
    })
  };

  onCancel = () => {
    //this.props.navigate('/login')
    this.setState({
      cancelClicked: true
    });
    console.log(this.state.cancelClicked);
  }

  // when the user hits submit, process the Signup through the API
  submitHandler = event => {
    //keep the form from actually submitting
    event.preventDefault();

    //Michaels Error Checking line >:)

    // Make sure EMAIL is filled out
    if (this.state.email === "") {
      this.setState({
        emailErrors: true,
        passwordErrors: false,
        retypedPassword: false,
      });
      return;
    } else {
      this.setState({
        emailErrors: false,
      });
    }

    // Original password Checking
    if (this.state.password === "") {
      this.setState({
        passwordreErrors: true,
        passwordreErrorsReturn: "Please retype password!",
      });
      return;
    } else {
      this.setState({
        passwordreErrors: false,
        passwordreErrorsReturn: "",
      });
    }

    if (this.state.password !== this.state.retypedPassword) {
      this.setState({
        passwordErrors: true,
        passwordreErrors: true,
        passwordErrorsReturn: "Passwords are not the same!",
        passwordreErrorsReturn: "Passwords are not the same!",
      });
      return;
    } else {
      this.setState({
        passwordErrors: false,
        passwordreErrors: false,
        passwordErrorsReturn: "",
        passwordreErrorsReturn: "",
      });
    }

    // Retyped password/ comparing 1st password entry
    if (this.state.retypedPassword === "") {
      this.setState({
        passwordreErrors: true,
        passwordreErrorsReturn: "Please retype password!",
      });
      return;
    } else {
      this.setState({
        passwordreErrors: false,
        passwordreErrorsReturn: "",
      });
    }

    // Make sure username is filled out
    if (this.state.username === "") {
      this.setState({
        userNameErrors: true,
      });
      return;
    } else {
      this.setState({
        userNameErrors: false,
      });
    }

    //keep the form from actually submitting
    event.preventDefault();

    console.log("Email:", this.state.email)
    //make the api call to the authentication page
    // fetch(process.env.REACT_APP_API_PATH+"/auth/signup", {
    fetch(process.env.REACT_APP_API_PATH + "/auth/signup", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
        'accept': '*/*'
      },
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password,
        attributes: {
          username: this.state.username,
          pfp: "https://webdev.cse.buffalo.edu/hci/api/uploads/files/ZkhMxfMTnbdJywLC26lZDX5nox35VJatc3rcwIq9nOw.gif",
          totalLikes: 0
        }
      })
    }).then(updateSubmit => {
      if (!updateSubmit.ok) {
        this.setState({
          generalErrors: true,
          generalOutput: "Ooops something went wrong! Please reload page.",
        });
        return;
      }
      this.setState({
        submitClicked: true
      })
    });
  }

  render() {
    // console.log("Rendering login, token is " + sessionStorage.getItem("token"));
    if (!sessionStorage.getItem("token")) {
      return (
        <form onSubmit={this.submitHandler} className="registerform">
          <div class="registercontainer">

            <div class="titlebox">
              <p class="logintitle">Create Account</p>
            </div>
            {this.state.generalErrors ? <div className="mainerrorfield"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">{this.state.generalOutput}</div></div> : ""}

            <div class="emailbox">
              <label for="reg-emailfield">Email</label>
              <input class="loginfield" id="reg-emailfield" type="email" onChange={this.emailChangeHandler} />
            </div>
            {this.state.emailErrors ? <div className="errorfield"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">Please enter a valid email.</div></div> : ""}

            <div class="usernamebox">
              <label for="reg-usernamefield">Username</label>
              <input class="loginfield" id="reg-usernamefield" type="text" onChange={this.usernameChangeHandler} />
            </div>
            {this.state.userNameErrors ? <div className="errorfield"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">Please enter a valid username</div></div> : ""}

            <div class="passwordbox">
              <label for="reg-passwordfield">Password</label>
              <input class="loginfield" id="reg-passwordfield" type="password" onChange={this.passwordChangeHandler} />
            </div>
            {this.state.passwordErrors ? <div className="errorfield"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">{this.state.passwordErrorsReturn}</div></div> : ""}

            <div class="retypebox">
              <label for="reg-retypefield">Retype Password</label>
              <input class="loginfield" id="reg-retypefield" type="password" onChange={this.retypeCheck} />
            </div>
            {this.state.passwordreErrors ? <div className="errorfield"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">{this.state.passwordreErrorsReturn}</div></div> : ""}

            <div class="submissionbox">
              <input type="submit" value="Sign Up" className="loginbutton" />
              <input type="reset" value="Cancel" className="cancelbutton" onClick={this.onCancel} />
              {this.state.cancelClicked ? <Navigate to="/login" /> : ""}
              {this.state.submitClicked ? <Navigate to="/login" /> : ""}
            </div>

          </div>
          <p>{this.state.alanmessage}</p>
        </form>
      );
    } else {
      console.log("Returning welcome message");
      if (this.state.username) {
        return <p>Welcome, {this.state.username}</p>;
      } else {
        return <p>{this.state.alanmessage}</p>;
      }
    }
  }
}
